export default __webpack_public_path__ + "static/media/stock.fd66171c.png";